
import {initWebComponent} from "@/helpers/web-component-helper";
import {initPopper} from "@/modules/popper";

export class LayerInfoInfoComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `
<div class="info-menu-info-header info-menu-info-draggable">
     <div class="card mb-3 mr-3 bg-lighter pb-2 mt-3" style="border-radius: 0 10px 10px 10px;">
      <div class="card-header font-weight-bold p-2 ">
         <h2>
             <span class="fa fa-info title-icon"></span>
             <layout-language data-key="information"></layout-language>
             <button class="btn icon-btn btn-sm btn-outline-secondary float-right btnHideInfoMenu">
                <span class="fa fa-times"></span>
             </button>
         </h2>
     </div>
        <div id="divInfoMenuInfoEmpty" class="info-menu-info">
            <div class="card-body pl-2" style="margin-top:20px">
                <p>
                    Klik op een object in de kaart voor informatie
                </p>
            </div>
        </div>
    </div>
</div>
`;
        initWebComponent(this, template)

        initPopper()
    }
}

